import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import JSONPretty from "react-json-pretty";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";

const useStyles = makeStyles({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "0px",
    backgroundColor: "#f3f6f9",
    border: "solid 1px #ccd6e3",
  },
  input: {
    marginLeft: "0px",
    flex: 1,
    lineHeight: "2em",
  },
  iconButton: {
    padding: 10,
  },
  indicator: {
    backgroundColor: "#faa700",
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const Debugger = (props) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const events = useSelector((state) => {
    return state.ticker.events;
  });
  const logs = useSelector((state) => {
    return state.ticker.logs;
  });
  const ticker = useSelector((state) => {
    return state.ticker;
  });

  const auth = useSelector((state) => {
    return state.auth;
  });

  const [ticker_data, setTickerData] = useState({});
  useEffect(() => {
    const td = { ...ticker };
    td["sip_user"] = ticker.sip_user ? "1" : "0";
    setTickerData(td);
  }, [ticker]);

  const [winState, setWinState] = useState("min");

  return (
    <div
      className="m-4 p-7"
      style={{
        border: "2px solid grey",
        position: "absolute",
        right: 0,
        bottom: "120px",
        background: "white",
        width: winState == "min" ? "20px" : "480px",
        height: winState == "min" ? "20px" : "450px",
        zIndex: 10,
        overflow: "auto",
      }}
    >
      {winState == "min" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="click-icon">
            <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
                setWinState("max");
              }}
            >
              <img
                alt=""
                className="header-close-icon"
                src={toAbsoluteUrl("/media/sr/icons/ticker-maximize.svg")}
              />
            </a>
          </div>
        </div>
      )}
      {winState !== "min" && (
        <>
          <div className="d-flex justify-content-between align-items-center  live-call-header">
            <div
              className="header-content"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <h6>
                  Ticker: debug ({events.length}) {ticker.call_state}{" "}
                  {ticker.view_state} {ticker_data.sip_user}
                </h6>
              </div>
              <div
                className="click-icon"
                onClick={() => {
                  setWinState("min");
                }}
              >
                <img
                  alt=""
                  className="header-close-icon"
                  src={toAbsoluteUrl("/media/sr/icons/ticker-minimize.svg")}
                />
              </div>
            </div>
          </div>

          <div className="ticker-tab-header">
            <Tabs
              value={value}
              onChange={handleChange}
              classes={{
                indicator: classes.indicator,
                text: classes.text,
              }}
              variant="fullWidth"
            >
              <Tab label="Events" {...a11yProps(0)} />
              <Tab label="Ticker State" {...a11yProps(1)} />
              <Tab label="Auth State" {...a11yProps(1)} />
            </Tabs>
          </div>
          <TabPanel value={value} index={0}>
            <ul>
              <li>transfer_type {ticker_data.transfer_type}</li>
              <li>transfer_state {ticker_data.transfer_state}</li>
              <li>transfer_error {ticker_data.transfer_error}</li>
              <li>txnid {ticker_data.txnid}</li>

              <li>view_state {ticker_data.view_state}</li>
              <li>call_state {ticker_data.call_state}</li>
              {ticker_data.conference_agent && (
                <li>
                  conf agent{" "}
                  <JSONPretty data={ticker_data.conference_agent}></JSONPretty>
                </li>
              )}
            </ul>

            <ul>
              {logs.map((e, i) => {
                return (
                  <li key={i}>
                    #{i} : <JSONPretty data={e}></JSONPretty>
                  </li>
                );
              })}
            </ul>

            <ul>
              {events.map((e, i) => {
                return (
                  <li key={i}>
                    <JSONPretty data={e}></JSONPretty>
                  </li>
                );
              })}
            </ul>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ul>
              <li>sip_call_event_type:{ticker.sip_call_event_type}</li>
              <li>sip_call_event:{JSON.stringify(ticker.sip_call_event)}</li>
              <li>is_sip_call:{ticker.is_sip_call}</li>
            </ul>
            <JSONPretty data={ticker_data}></JSONPretty>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <JSONPretty data={auth}></JSONPretty>
          </TabPanel>
        </>
      )}
    </div>
  );
};
